const axios = require('axios');
import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
//import { getFirestore, where } from "firebase/firestore";
//import { collection, doc, setDoc, getDoc, getDocs, addDoc, updateDoc, query, orderBy } from "firebase/firestore";
import * as model from './model';

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
    apiKey: "AIzaSyB8LReCXWSV10kkshWb07h4uOLLDgwfQy0",
    authDomain: "thai-pbs-special-project.firebaseapp.com",
    databaseURL: "https://thai-pbs-special-project-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "thai-pbs-special-project",
    storageBucket: "thai-pbs-special-project.appspot.com",
    messagingSenderId: "257657633521",
    appId: "1:257657633521:web:7a52269155247f7cec8750",
    measurementId: "G-0RM43HSEJP"
  };

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
//const db = getFirestore(app);


const authenticateUser = function (liffUser) {
    return new Promise((resolve, reject) => {
        /*
        liffUser
        {
            amr: ['pwd']
            aud: "1481726304"
            exp: 1650515634
            iat: 1650512034
            iss: "https://access.line.me"
            name: "Tom Saturn"
            picture: "https://profile.line-scdn.net/0h342l8-6hbBsPFXs11CcTTDNQYnZ4O2pTd3cheyJGMS8lcCIYMiMieyITMip2dn5JM3AqdX1BZ34q"
            sub: "U05880f12f4803ee80036f64b4dfcaae9"
        }
        */
        let user = model.default.User({
            uid: liffUser.sub,
            name: liffUser.name,
            picture: liffUser.picture,
        })

        getUser(user.uid).then(val => {
            if (val == null) {
                //new User
                createUser(user).then(() => {
                    resolve(user)
                }).catch(err => {
                    reject(err)
                })
            } else {
                //existing User
                resolve(val)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

const getUser = function (uid) {
    return new Promise((resolve, reject) => {
        var config = {
            method: 'get',
            url: `https://asia-southeast1-thai-pbs-special-project.cloudfunctions.net/bkkelectionpoll/get-user?uid=${uid}`,
            headers: {}
        };

        axios(config)
            .then(function (response) {
                if (response.data.status) {
                    resolve(response.data.content)
                } else {
                    resolve(false)
                }
            })
            .catch(function (error) {
                reject(error)
            });

    })
}

const createUser = function (user) {
    return new Promise((resolve, reject) => {
        var config = {
            method: 'post',
            url: 'https://asia-southeast1-thai-pbs-special-project.cloudfunctions.net/bkkelectionpoll/create-user',
            headers: {
                'Content-Type': 'application/json'
            },
            data: user
        };

        axios(config)
            .then(function (response) {
                resolve(response.data.status)
            })
            .catch(function (error) {
                reject(error)
            });

    })
}

const updateUser = function (uid, data) {
    return new Promise((resolve, reject) => {
        var config = {
            method: 'post',
            url: `https://asia-southeast1-thai-pbs-special-project.cloudfunctions.net/bkkelectionpoll/create-user?uid=${uid}`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios(config)
            .then(function (response) {
                resolve(response.data.status);
            })
            .catch(function (error) {
                reject(error);
            });

    })
}

const commitVote = function (vote, user) {
    return new Promise((resolve, reject) => {
        var data = JSON.stringify({
            vote: vote,
            user: user
        });

        var config = {
            method: 'post',
            url: 'https://asia-southeast1-thai-pbs-special-project.cloudfunctions.net/bkkelectionpoll/commit-vote',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios(config)
            .then(function (response) {
                resolve(response.data.status);
            })
            .catch(function (error) {
                reject(error);
            });

    })
}

const getVotesByUser = function (uid) {
    return new Promise((resolve, reject) => {
        var config = {
            method: 'get',
            url: `https://asia-southeast1-thai-pbs-special-project.cloudfunctions.net/bkkelectionpoll/get-votes-by-user?uid=${uid}`,
            headers: {}
        };

        axios(config)
            .then(function (response) {
                if (response.data.status) {
                    resolve(response.data.content)
                } else {
                    resolve(false)
                }
            })
            .catch(function (error) {
                reject(error);
            });

    })
}

const getAllCandidates = function () {
    return new Promise((resolve, reject) => {
        var config = {
            method: 'get',
            url: 'https://asia-southeast1-thai-pbs-special-project.cloudfunctions.net/bkkelectionpoll/get-all-candidates',
            headers: {}
        };

        axios(config)
            .then(function (response) {
                if (response.data.status) {
                    resolve(response.data.content)
                } else {
                    resolve(false)
                }
            })
            .catch(function (error) {
                reject(error);
            });

    })
}

const getCandidate = function (id) {
    return new Promise((resolve, reject) => {
        var config = {
            method: 'get',
            url: `https://asia-southeast1-thai-pbs-special-project.cloudfunctions.net/bkkelectionpoll/get-candidate?id=${id}`,
            headers: {}
        };

        axios(config)
            .then(function (response) {
                if (response.data.status) {
                    resolve(response.data.content)
                } else {
                    resolve(false)
                }
            })
            .catch(function (error) {
                reject(error);
            });

    });
}

export default {
    app: app,
    analytics: analytics,
    //db: db,
    authenticateUser: authenticateUser,
    getUser: getUser,
    createUser: createUser,
    updateUser: updateUser,
    commitVote: commitVote,
    getAllCandidates: getAllCandidates,
    getCandidate: getCandidate,
    getVotesByUser: getVotesByUser
}